import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ImageUpload from './ImageUploader';

const GetImage = () => {
    const [images, setImages] = useState([]);

    const fetchImages = async () => {
        const res = await axios.get('http://localhost:5000/api/auth/get-image');
        setImages(res.data);
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const deleteImage = async (id) => {
        try {
            await axios.delete(`https://travelback-thuw.onrender.com/api/auth/delete-image/${id}`);
            fetchImages();
            alert('Image deleted successfully!');
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };
    return (
        <div>
            <h1>Image Upload App</h1>
            <ImageUpload onUpload={fetchImages} />
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {images.map(img=> (
                    <div className='uploader' key={img._id}>
                        <img key={img._id} src={`https://travelback-thuw.onrender.com/${img.path}`} alt="uploaded" style={{ width: '270px', height: 'auto' }} />
                        <button onClick={() => deleteImage(img._id)}>Delete</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GetImage;